import { gql } from "@apollo/client";

export const createFiledTokens = gql`
mutation getPrePaymentDetailsStripe($amount : String!) {
  getPrePaymentDetailsStripe(amount: $amount) {
    tax
    callBackAppUrl 
    callBackApiUrl
    merchantTransactionId
}
}
`;

export const callPaymentIntentDetails = gql`
mutation setupPaymentWithStripe {
  setupPaymentWithStripe {
    clientSecret
    clientPublicKey
    paymentIntentId
  }
}
`;
